import React from "react";
import Icons from "../../Config/Images";
import Strings from "../../Config/Strings";
import Fonts from "../../Config/Fonts";
import Colors from "../../theme/Colors";

const CustomEmptyView = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img
        src={Icons.emptyImg}
        style={{ height: "22rem", width: "30rem", objectFit: 'cover' }}
        alt="Empty"
      />
      <p
        style={{
          fontSize: 17,
          fontWeight: 600,
          fontFamily: Fonts.NunitoSans,
          color: Colors.black,
        }}
      >
        {Strings.NoDataFound}
      </p>
    </div>
  );
};

export default CustomEmptyView;
